/* eslint-disable max-len */
import IBloczekMarkerConfig from '~/components/map/types/marker/config/IBloczekMarkerConfig';

const buildMarkerSvgUrl = ({
  text,
  metrics,
  fillColor,
  textColor,
  textBackgroundColor,
  textBorderColor,
  iconBase64,
  checkBase64,
}: IBloczekMarkerConfig): string => `data:image/svg+xml;utf-8,
    <svg height="${metrics.main.height}" width="${metrics.main.width}" xmlns="http://www.w3.org/2000/svg">
    <rect y="${metrics.image.containerY}" x="${metrics.image.containerX}" height="${metrics.image.containerHeight}" width="${
  metrics.image.containerWidth
}" rx="${metrics.image.containerRadius}" fill="${fillColor}"></rect>
    <image width="${metrics.image.width}" height="${metrics.image.height}" x="${metrics.image.x}" y="${
  metrics.image.y
}" href="${iconBase64}"/>
    <g>
      <svg width="${metrics.text.width}" height="${metrics.text.height}">
        <rect
          x="${metrics.text.backgroundX}"
          y="${metrics.text.backgroundY}"
          height="${metrics.text.backgroundHeight}"
          width="${metrics.text.backgroundWidth}"
          rx="${metrics.text.radius}"
          ry="${metrics.text.radius}"
          fill="${textBackgroundColor}"
          stroke-width="${metrics.text.borderSize}"
          stroke="${textBorderColor}"
        ></rect>
        <text
          x="50%"
          y="${metrics.text.y}"
          dominant-baseline="middle"
          text-anchor="middle"
          font-family="Roboto, Arial, sans-serif"
          font-weight="700"
          font-size="${metrics.text.fontSize}"
          fill="${textColor}"
        >
        ${text}
        </text>
      </svg>
    </g>
    <g transform="translate(${metrics.triangle.x},${metrics.triangle.y})">
      <svg>
        <polygon fill="${fillColor}" points="0,0 ${metrics.triangle.size * 2},0, ${metrics.triangle.size},${metrics.triangle.size}" />
      </svg>
    </g>
    <circle cx="${metrics.point.x}" cy="${metrics.point.y}" r="${metrics.point.size / 2}" fill="${fillColor}"/>
    <image width="${metrics.point.checkSize}" height="${metrics.point.checkSize}" x="${metrics.point.checkX}" y="${
  metrics.point.checkY
}" href="${checkBase64}"/>
  </svg>`;
export default buildMarkerSvgUrl;
